<template>
  <Modal title="SMS表記店名" @close="close">
    <div>
      <TextInput
        maxlength="30"
        v-model="smsName"
        @compositionstart="compositionstart"
        @compositionend="compositionend"
      />
      <div class="note">
        <p>※カンマ、スペースも文字数に含まれます。</p>
        <p>{{ smsName.length }}<span>/30</span></p>
      </div>
    </div>
    <template #footer-center>
      <Button @click="close">戻る</Button>
      <Button primary :disabled="!isChanged" @click="save">保存</Button>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import { isEqual } from 'lodash'
import { relaceToHalf, hasFullWidth } from '@/utils/date'
import { checkModelDependent, replaceKanaFullToHalf, hasHalfKana } from '@/utils/string'
import Button from '@/components/atoms/Button'
import TextInput from '@/components/atoms/TextInput'
import Modal from '@/components/molecules/Modal'
import Dialog from '@/components/molecules/ModalDialog'

export default {
  name: 'SmsNameModal',
  components: {
    Button,
    Modal,
    TextInput,
  },
  props: {
    /** SMS表記店名 */
    name: { type: String, default: '' },
  },
  data() {
    return {
      editName: '',
      composing: false,
    }
  },
  computed: {
    ...mapState({
      currentStore: state => state.stores.current.store,
    }),
    smsName: {
      get() {
        return this.editName
      },
      set(val) {
        this.edit(val)
      },
    },
    isChanged() {
      return this.editName && !isEqual(this.editName, this.name) && this.editName.trim().length !== 0
    },
  },
  mounted() {
    this.editName = this.name || this.currentStore.name
  },
  methods: {
    edit(val) {
      if (!this.composing) {
        if (hasFullWidth(val) || hasHalfKana(val)) {
          // 全角英数記号を半角に変換
          // 半角カナを全角に変換
          this.editName = replaceKanaFullToHalf(relaceToHalf(val))
        } else {
          this.editName = val
        }
      }
    },
    compositionstart() {
      this.composing = true
    },
    compositionend(e) {
      this.composing = false
      this.edit(e.target.value)
    },
    close() {
      this.$emit('close')
    },
    async save() {
      if (checkModelDependent(this.editName)) {
        await Dialog.show({
          title: 'SMS表記店名',
          message: 'SMS表記店名に機種依存文字が使用されています。\n入力内容を確認してください。',
          okText: '閉じる',
        })
        return
      }
      this.$emit('save', this.editName)
    },
  },
}
</script>

<style lang="postcss" scoped>
.section {
  align-items: center;
  box-sizing: border-box;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: center;
}

.form {
  align-items: center;
  grid-gap: 24px;
  grid-template-columns: 88px 1fr;

  > dt {
    font-size: 21px;
    font-weight: normal;
    padding: 0;
  }
}

>>> .time-input {
  width: 136px;
}

.note {
  color: var(--very-dark-gray);
  display: flex;
  font-size: 13px;
  padding-top: 8px;

  :last-of-type {
    margin-left: auto;
  }

  span {
    font-size: 11px;
  }
}
</style>
